import { AfterContentInit, Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { UserService } from './angie-shared/services/user.service';
import { StateService } from './core';
import { InsightsService } from './modules/insights/services/insights.service';

/**
 * List of urls where tracking must be disabled.
 * e.g. Authorization pages
 */
const SKIP_TRACKING: RegExp[] = [
	/^\/users\/sign_in/,
	/^\/users\/auth/,
	/^\/users\/sign_up/,
	/^\/users\/confirmation/,
	/^\/users\/code_redeem/,
	/^\/accept_invitation/,
	/^\/users\/password/,
	/^\/users\/privacy-policy/
];

/**
 * App Component - our main bootstrap component.
 * This component has been initialized first and all the other components will get loaded from here.
 * This one is used inside our index.html.erb where we define our root level tag (this).
 */
@Component({
	selector: 'angie-app',
	templateUrl: './app.component.html'
})
export class AppComponent implements AfterContentInit, OnInit {
	/**
	 * Constructor
	 */
	constructor(
		private readonly meta: Meta,
		private readonly stateService: StateService,
		private readonly userService: UserService,
		private readonly router: Router,
		private readonly insightsService: InsightsService
	) {}

	isLearner = this.userService.isLearner();
	isLoggedIn = this.stateService.luUser;
	isInLearnerView = this.stateService.isInLearnerView();
	ai_assistant = this.stateService.portalMeta?.ai_assistant; // from luphub
	ai_assistant_enabled = this.stateService.portalMeta?.ai_assistant_enabled; // from settings page
	aiSmartSearchEnabled =
		this.ai_assistant && this.ai_assistant_enabled && (this.isLearner || this.isInLearnerView) && this.isLoggedIn; // all conditions to show ai smart search

	ngOnInit(): void {
		this.router.events
			.pipe(
				filter((event): event is NavigationEnd => event instanceof NavigationEnd),
				filter((event): event is NavigationEnd => SKIP_TRACKING.findIndex(it => it.test(event.url)) < 0)
			)
			.subscribe(event => this.insightsService.pageViewEvent(event));

		// Initialize Pendo analytics
		if (typeof initPendo === 'function') {
			initPendo();
		}
	}

	/**
	 * After View Init LifeCycle hook
	 */
	ngAfterContentInit(): void {
		this.setXSRFToken();
	}

	/**
	 * Method to get called after content has been inited
	 * We're going to set xsrfToken token here which we'll read from meta csrf-token and set it into state service
	 */
	private setXSRFToken(): void {
		this.stateService.xsrfToken = this.meta.getTag('name="csrf-token"').content;
	}
}

// Declare the global initPendo function
declare function initPendo(): void;
